import { render, staticRenderFns } from "./ModelFile.vue?vue&type=template&id=3608ebd4&scoped=true"
import script from "./ModelFile.vue?vue&type=script&lang=ts"
export * from "./ModelFile.vue?vue&type=script&lang=ts"
import style0 from "./ModelFile.vue?vue&type=style&index=0&id=3608ebd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3608ebd4",
  null
  
)

export default component.exports